<template>
    <div>
        <b-breadcrumb :items="breadCrumbs" />
        <div class="row mb-3">
            <div class="col-12">
                <b-btn
                    variant="primary"
                    size="md"
                    class="float-right"
                    :to="'/envelopes/add'"
                >Add Envelopes
                </b-btn
                >
            </div>
        </div>

        <b-row class="mt-3">
            <b-col md="12">
                <b-table :items="envelopes" :fields="fields" v-if="envelopes">
                    <template slot="cell(stock)" slot-scope="row">
                        <ul>
                            <li :key="index" v-for="(item, index) in row.item">
                                {{
                                    item.model + " X " + item.name + " (" + item.weight + ")"
                                }}
                            </li>
                        </ul>
                    </template>
                    <template slot="cell(actions)" slot-scope="row">
                        <div style="width:300px;">
                            <b-button
                                size="sm"
                                variant="warning"
                                class="ml-2"
                                :to="'/envelopes/' + row.item.envelope_id + '/edit/'"
                            >Edit
                            </b-button
                            >
                            <b-button
                                size="sm"
                                variant="danger"
                                class="ml-2"
                                @click="deleteConfirm(row.item.envelope_id)"
                            >Delete
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </b-col>
        </b-row>

        <b-row v-if="!envelopes || envelopes.length == 0">
            <b-col md="6" class="my-1 offset-md-3">
                <b-alert show variant="success">No Envelopes yet!</b-alert>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "envelopes",
    components: {},
    data() {
        return {
            envelopes: null,
            fields: [
                { key: "envelope_id", label: "#", sortable: true },
                { key: "model", label: "Model" },
                { key: "name", label: "Name" },
                { key: "weight", label: "Weight" },
                { key: "actions", label: "" }
            ],
            breadCrumbs: [
                { text: "Dashboard", to: { name: "dashboard" } },
                { text: "Envelopes", active: true }
            ]
        };
    },
    mounted: function () {
        this.getEnvelopes();
    },
    methods: {
        getEnvelopes: function () {
            let loader = this.$loading.show();
            this.$http.get(this.APIURL + this.BRAND + "/envelopes").then(
                response => {
                    this.envelopes = response.data.envelopes;
                    loader.hide();
                },
                error => {
                    loader.hide();
                    // console.log(error);
                }
            );
        },
        deleteConfirm(id) {
            this.$swal({
                title: "Are you sure?",
                text: "You want to delete envelope: " + id,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then(result => {
                if ( result.value ) {
                    this.deleteEnvelope(id);
                }
            });
        },
        deleteEnvelope(id) {
            let loader = this.$loading.show();
            this.$http.delete(this.APIURL + this.BRAND + "/envelopes/" + id).then(
                () => {
                    this.$swal({
                        title: "Success!",
                        showConfirmButton: false,
                        timer: 1000,
                        html: "Envelop deleted successfully!",
                        type: "success",
                        onClose: () => {
                            loader.hide();
                            this.getEnvelopes();
                        }
                    });
                },
                error => {
                    console.log(error);
                }
            );
        },
    }
};
</script>
